import React from 'react'
import TierDetails from './TierDetails'
import TierListe from './TierListe';

const Tiere = () => {
    return (
        <div>
            <div>
                {TierListe.map((tier, index) => (
                    <TierDetails key={tier.name} tier={tier} tierListe={TierListe} index={index}/>
                ))}
            </div>
        </div>
    );
}

export default Tiere;

